import React from 'react';
import LdaDeliverableRow from './LdaDeliverableRow';

const TYPE_LABELS = { project: 'Projet', project_node: 'Nœud', phase: 'Phase', lot: 'Lot' };

export default function LdaTreeNode({ node, depth = 0, expanded, onToggle, renderDeliverable }) {
  if (node.type === 'deliverable') return <>
    <LdaDeliverableRow node={node} depth={depth} renderDeliverable={renderDeliverable} />
    {node.children.map((child) => <LdaDeliverableRow key={child.id} node={child} depth={depth + 1} renderDeliverable={renderDeliverable} />)}
  </>;
  const isExpanded = expanded.has(node.id);
  return <div className={`lda-tree-node lda-tree-node--${node.type}`}>
    <button className="lda-tree-node__group" type="button" onClick={() => onToggle(node.id)} style={{ '--tree-depth': depth }} aria-expanded={isExpanded}>
      <span className="lda-tree-node__toggle">{isExpanded ? '−' : '+'}</span><span className="lda-tree-node__type">{TYPE_LABELS[node.type]}</span>
      <strong>{node.label}</strong>{node.metadata.code && <code>{node.metadata.code}</code>}
      <span className="lda-tree-node__count">{node.metadata.deliverableCount} livrable{node.metadata.deliverableCount > 1 ? 's' : ''}</span>
      <span className="lda-tree-node__progress"><i style={{ width: `${node.metadata.progress}%` }} />{node.metadata.progress}%</span>
    </button>
    {isExpanded && <div className="lda-tree-node__children">{node.children.map((child) => <LdaTreeNode key={child.id} node={child} depth={depth + 1}
      expanded={expanded} onToggle={onToggle} renderDeliverable={renderDeliverable} />)}</div>}
  </div>;
}
